const mapValues= require('lodash/mapValues');
const omitBy= require('lodash/omitBy');


export function updateZoteroPlugin(){
    setTimeout(()=>{
        let ev = document.createEvent('HTMLEvents');
        ev.initEvent('ZoteroItemUpdated', true, true);
        document.dispatchEvent(ev);              
        }, 2000);
};

export function encodeZoteroValue (value){
    let params=getQueryParams(value);
    params= omitBy(params, (val)=> val === '');
    if (!params['rft.aufirst'] && params['rft.aulast']){ //hack because of a bug in zotero plugin
        params['rft.aufirst']= params['rft.aulast'];
    }
    params= mapValues(params, (val)=>encodeURIComponent(val)); 
    return serialize(params);
};

function escapeCharachters(s: string){
    return s.replace(/%/g, '%25').replace(/#/g, '%23').replace(/&/g, '%26')
    .replace(/\+/g, '%2B').replace(/\//g, '%2F').replace(/</g, '%3C').replace(/=/g, '%3D')
    .replace(/>/g, '%3E').replace(/\?/g, '%3F').replace(/:/g, '%3A');    
}

function getQueryParams(url){
    let qparams = {},
        parts = (url||'').split('?'),
        qparts, qpart,
        i=0;

    if(parts.length <= 1 ){
        return qparams;
    }else{
        qparts = parts[1].split('&');
        for(i in qparts){

            qpart = qparts[i].split('=');
            qparams[decodeURIComponent(qpart[0])] = 
                           decodeURIComponent(qpart[1] || '');
        }
    }

    return qparams;
};

function serialize(obj) {
  let str = [];
  for(let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(p + "=" + obj[p]);
    }
  return str.join("&");
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/zoteroUtil.ts